import { useEffect, useState } from 'react';
import { ShieldCheck, Loader2 } from 'lucide-react';
import api from '@/lib/api';

// Lightweight dashboard badge: Amber while the silent salary-branch backfill
// is reconciling historical cross-branch rows, Green once a sweep completes.
export const LaunchHealthBadge = () => {
  const [health, setHealth] = useState(null);

  useEffect(() => {
    let stop = false;
    const load = async () => {
      try {
        const { data } = await api.get('/system/launch-health');
        if (!stop) setHealth(data);
      } catch { /* silent — badge is best-effort */ }
    };
    load();
    // Poll while amber so it flips to green on its own once the sweep finishes.
    const id = setInterval(() => { if (!stop) load(); }, 15000);
    return () => { stop = true; clearInterval(id); };
  }, []);

  if (!health) return null;
  const green = health.state === 'green';

  return (
    <span
      data-testid="launch-health-badge"
      data-state={health.state}
      title={green
        ? 'Launch Health: all historical cross-branch records are clean'
        : 'Launch Health: reconciling historical records…'}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[12px] font-medium border ${
        green
          ? 'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/20 dark:text-emerald-300 dark:border-emerald-800/40'
          : 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/20 dark:text-amber-300 dark:border-amber-800/40'
      }`}
    >
      {green
        ? <ShieldCheck size={14} className="shrink-0" />
        : <Loader2 size={14} className="shrink-0 animate-spin" />}
      Launch Health
      {green ? <span className="font-semibold">✓</span> : <span>· syncing</span>}
    </span>
  );
};

export default LaunchHealthBadge;
